import { create } from 'zustand'
import { liveStore, type LiveSlice } from './live/live'
import {
  animationQueueLiveStore,
  type AnimationQueueSlice,
} from './live/live-animation-queue'
import { chatLiveStore, type ChatLiveSlice } from './live/live-chat'
import { liveEmojiStore, type LiveEmojiSlice } from './live/live-emoji'
import { liveGiftStore, type LiveGiftSlice } from './live/live-gift'
import { liveLayoutsStore, type LiveLayoutsSlice } from './live/live-layouts'
import { modalsLiveStore, type ModalLiveSlice } from './live/live-modals'
import { notifyLiveStore, type NotifyLiveSlice } from './live/live-notify'
import {
  liveRocketGameStore,
  type LiveRocketGameSlice,
} from './live/live-rocket-game'

interface Slice
  // UserSlice,
  extends LiveSlice,
    AnimationQueueSlice,
    ChatLiveSlice,
    ModalLiveSlice,
    NotifyLiveSlice,
    LiveGiftSlice,
    // LivePkSlice ,
    LiveEmojiSlice,
    // LiveMultiSlice  ,
    // LiveEffectSlice,
    LiveLayoutsSlice,
    LiveRocketGameSlice,
    ChatLiveSlice {}

export const useGlobalStore = create<Slice>()((...actions) => ({
  // ...userStore(...actions),
  // ...chatStore(...actions),
  ...chatLiveStore(...actions),
  ...modalsLiveStore(...actions),
  ...notifyLiveStore(...actions),
  ...animationQueueLiveStore(...actions),
  ...liveStore(...actions),
  ...liveGiftStore(...actions),
  // ...livePkStore(...actions),
  ...liveEmojiStore(...actions),
  // ...liveMultiStore(...actions),
  // ...liveEffectStore(...actions),
  ...liveLayoutsStore(...actions),
  ...liveRocketGameStore(...actions),
}))
